var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var UP_KEY = ['ArrowUp', 'Up'];
var DOWN_KEY = ['ArrowDown', 'Down'];
var LEFT_KEY = ['ArrowLeft', 'Left'];
var RIGHT_KEY = ['ArrowRight', 'Right'];
var NAVIGATION_KEYS = __spreadArrays(UP_KEY, DOWN_KEY, LEFT_KEY, RIGHT_KEY);
var ESCAPE_KEY = ['Escape', 'Esc'];
var DELETE_KEY = 'Delete';
var BACKSPACE_KEY = 'Backspace';
var ENTER_KEY = 'Enter';
var DELETE_KEYS = [DELETE_KEY, BACKSPACE_KEY];
export { DELETE_KEYS as D, ESCAPE_KEY as E, LEFT_KEY as L, NAVIGATION_KEYS as N, RIGHT_KEY as R, UP_KEY as U, DOWN_KEY as a, ENTER_KEY as b };
